<template>
  <tw-custom-dialog transition="fadet"
                    width="600"
                    v-model="dialog">
    <template v-slot:activator="{on}">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Cancelar agendamento
    </template>
    <template>
      <v-row dense>
        <v-col cols="12" sm="12" md="12" v-if="this.cancelamentoEdit">
          <v-list-item>
            <v-list-item-icon>
              <v-icon :color="this.cancelamentoEdit.cliente.cor">mdi-account-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ this.cancelamentoEdit.cliente.nome }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon :color="this.cancelamentoEdit.cliente.cor">
                mdi-clock-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ this.horaInicio | time }} até
                {{ this.horaFim | time }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon :color="this.cancelamentoEdit.cliente.cor">
                mdi-calendar
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ this.data | date }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="12" md="12">
          <v-textarea outlined
                      class="required"
                      counter="255"
                      v-model="cancelamentoEdit.motivo"
                      rows="3"
                      label="Motivo"/>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn color="primary"
             :loading="loadingForm"
             :disabled="$v.$invalid"
             @click="save">
        Salvar
      </v-btn>
      <v-btn @click="close">Cancelar</v-btn>
    </template>
  </tw-custom-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import CancelamentoService from '@/api/cancelamento-service';
import { required, maxLength } from 'vuelidate/lib/validators';

const reset = () => ({
  cliente: {
    nome: null,
  },
  agendamento: null,
  data: null,
  horaInicio: null,
  horaFim: null,
  motivo: null,
});

export default {
  props: {
    agendamento: {
      type: Object,
      required: true,
    },
    data: {
      type: String,
      required: true,
    },
    horaInicio: {
      type: String,
      required: true,
    },
    horaFim: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      cancelamentoEdit: reset(),
      dialog: false,
      loadingForm: false,
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    save() {
      this.loadingForm = true;
      CancelamentoService.save(this.cancelamentoEdit)
        .then(() => {
          this.close();
          this.$emit('update');
          this.$toast('Cancelamento salvo', { color: 'success' });
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
  },
  watch: {
    dialog() {
      this.cancelamentoEdit = reset();
      this.cancelamentoEdit.agendamento = cloneDeep(this.agendamento);
      this.cancelamentoEdit.cliente = cloneDeep(this.agendamento.cliente);
      this.cancelamentoEdit.data = this.data;
      this.cancelamentoEdit.horaInicio = this.horaInicio;
      this.cancelamentoEdit.horaFim = this.horaFim;
      this.$v.$reset();
    },
  },
  validations: {
    cancelamentoEdit: {
      cliente: {
        required,
      },
      motivo: {
        required,
        maxLength: maxLength(255),
      },
    },
  },
};
</script>

<style scoped>

</style>
